/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

import {CommissionId, CommissionInput} from "../__ignore/schemas";

/**
 * @summary Edit representative commission
 */
export const EditRepresentativeCommissionBody = CommissionInput;

export const EditRepresentativeCommissionResponse = zod.void();

/**
 * @summary Remove representative commission
 */
export const RemoveRepresentativeCommissionResponse = zod.void();

/**
 * @summary Add representative commission
 */
export const AddRepresentativeCommissionBody = CommissionInput;

export const AddRepresentativeCommissionResponse = CommissionId;
